import React, { createContext, useState, useContext } from "react";

const MatchingHeadingsContext = createContext();

export const MatchingHeadingsProvider = ({ children }) => {
  const initialDraggableList = [
    "How a concept from one field of study was applied in another",
    "A lack of investment in driver training",
    "Areas of doubt and disagreement between experts",
    "How different countries have dealt with traffic congestion",
    "The impact of driver behavior on traffic speed",
  ];

  const placeholderNumbers = [16, 17, 18, 19, 20];
  const [draggableList, setDraggableList] = useState(initialDraggableList);
  const [droppedItems, setDroppedItems] = useState(Array(5).fill(null));

  const handleDrop = (item, targetIndex) => {
    if (targetIndex !== -1) {
      const currentItemInTarget = droppedItems[targetIndex];
      if (currentItemInTarget) {
        setDraggableList((prevList) => [...prevList, currentItemInTarget]);

        setDroppedItems((prevDroppedItems) => {
          const updatedDroppedItems = [...prevDroppedItems];
          updatedDroppedItems[targetIndex] = null;
          return updatedDroppedItems;
        });
      }

      const currentItemIndex = droppedItems.findIndex(
        (droppedItem) => droppedItem === item
      );
      if (currentItemIndex !== -1) {
        setDroppedItems((prevDroppedItems) => {
          const updatedDroppedItems = [...prevDroppedItems];
          updatedDroppedItems[currentItemIndex] = null;
          return updatedDroppedItems;
        });
      }

      setDroppedItems((prevDroppedItems) => {
        const updatedDroppedItems = [...prevDroppedItems];
        updatedDroppedItems[targetIndex] = item;
        return updatedDroppedItems;
      });

      setDraggableList((prevList) => prevList.filter((text) => text !== item));

    } else {
      setDraggableList((prevList) => [...prevList, item]);

      setDroppedItems((prevDroppedItems) => {
        const updatedDroppedItems = [...prevDroppedItems];
        updatedDroppedItems[prevDroppedItems.indexOf(item)] = null;
        return updatedDroppedItems;
      });
    }
  };

  const handleReturnToList = (item) => {
    setDroppedItems((prevDroppedItems) => {
      const updatedDroppedItems = [...prevDroppedItems];
      updatedDroppedItems[updatedDroppedItems.indexOf(item)] = null;
      return updatedDroppedItems;
    });

    setDraggableList((prevList) => [...prevList, item]);
  };

  return (
    <MatchingHeadingsContext.Provider
      value={{
        draggableList,
        droppedItems,
        handleDrop,
        handleReturnToList,
      }}
    >
      {children}
    </MatchingHeadingsContext.Provider>
  );
};

export const useMatchingHeadings = () => {
  const context = useContext(MatchingHeadingsContext);
  if (!context) {
    throw new Error(
      "useMatchingHeadings must be used within MatchingHeadingsProvider"
    );
  }
  return context;
};
